import React, { useState, useRef, useEffect } from 'react';
import './DemographicsRangeSelector/DemographicsRangeSelector.css';

import Bar from '../Charts/Bar';
import Gauge from '../Charts/Gauge';
import DemographicsRangeSelector from './DemographicsRangeSelector/DemographicsRangeSelector';

const Demographics = props => {
  const {
    results,
    headerStats,
    onToggleFilter,
    filterCollectDataGroups,
    activeFilters,
    unFilteredSideResults
  } = props;
  const [ageGroupsParent, setAgeGroupsParent] = useState(null);
  const [genderGroupsParent, setGenderGroupsParent] = useState(null);
  // const [employmentParent, setEmploymentParent] = useState(null);
  const [ageDemographicsActions, setAgeDemograpicsActions] = useState(false);
  const [genderDemographicsActions, setGenderDemograpicsActions] = useState(
    false
  );
  const [showRangeSelector, setShowRangeSelector] = useState(true);
  const [ageFilteringOnSelection, setAgeFilteringOnSelection] = useState(true);
  const [genderFilteringOnSelection, setGenderFilteringOnSelection] = useState(
    true
  );
  const [unfilteredAgeGroupsData, setUnfilteredAgeGroupsData] = useState(null);
  const [unfilteredGenderGroupsData, setUnfilteredGenderGroupsData] = useState(
    null
  );
  const [genderGroupsInChart, setGenderGroupsInChart] = useState(null);

  const dropdownTogglerRef = useRef(null);

  const groupTypes = {
    ageGroups: 'ageGroups',
    genders: 'genders'
  };

  let availableGenderGroupsInChart =
    genderGroupsInChart && genderGroupsInChart.length
      ? genderGroupsInChart
      : ['Male', 'Female'];

  if (
    !genderGroupsInChart &&
    unFilteredSideResults &&
    unFilteredSideResults[groupTypes.genders]
  ) {
    const genderGroupsWithResults = unFilteredSideResults[
      groupTypes.genders
    ].reduce(
      (acc, curr) => {
        if (
          (curr.xLabel === 'Unknown' || curr.xLabel === 'Other') &&
          curr.y > 0
        ) {
          return [...acc, curr.xLabel];
        }
        return acc;
      },
      ['Male', 'Female'] // Always display Male & Female genders in chart
    );

    setGenderGroupsInChart(genderGroupsWithResults);
    availableGenderGroupsInChart = genderGroupsWithResults;
  }

  useEffect(
    () => {
      if (activeFilters.length) {
        setUnfilteredAgeGroupsData(
          getUnfilteredGroupsData(groupTypes.ageGroups)
        );
      } else {
        setUnfilteredAgeGroupsData(null);
      }
    },
    [ageFilteringOnSelection, unFilteredSideResults.ageGroups]
  );

  useEffect(
    () => {
      if (activeFilters.length) {
        setUnfilteredGenderGroupsData(
          getUnfilteredGroupsData(groupTypes.genders)
        );
      } else {
        setUnfilteredGenderGroupsData(null);
      }
    },
    [genderFilteringOnSelection, unFilteredSideResults.genders]
  );

  const surveyHasMultipleLanguagesInResults =
    unFilteredSideResults &&
    unFilteredSideResults.languages &&
    unFilteredSideResults.languages.findIndex(
      language => language.value === '1.000'
    ) === -1;

  const activeAgeFilters =
    activeFilters &&
    activeFilters.length &&
    activeFilters.some(
      activeFilter =>
        activeFilter.valuePath &&
        activeFilter.valuePath === 'attributes.userData.age'
    );

  const activeGenderFilters =
    activeFilters &&
    activeFilters.length &&
    activeFilters.some(
      activeFilter =>
        activeFilter.valuePath &&
        activeFilter.valuePath === 'attributes.userData.gender'
    );

  const getUnfilteredGroupsData = type => {
    let unfilteredData = [...unFilteredSideResults[type]].map(group => ({
      ...group
    }));
    if (
      (type === groupTypes.ageGroups && ageFilteringOnSelection) ||
      (type === groupTypes.genders && genderFilteringOnSelection)
    ) {
      const filteredData = [...results[type]].map(group => ({
        ...group
      }));
      /* eslint-disable no-param-reassign */
      unfilteredData = unfilteredData.reduce(
        (unfilteredValuesWithoutSelection, currentDataPoint) => {
          if (filteredData && filteredData.length) {
            const matchingValue = filteredData.find(
              datapoint => datapoint.x === currentDataPoint.x
            );
            if (matchingValue) {
              currentDataPoint.y -= matchingValue.y;
            }
            if (currentDataPoint.y < 0) {
              currentDataPoint.y = 0;
            }
            unfilteredValuesWithoutSelection.push(currentDataPoint);
          }
          return unfilteredValuesWithoutSelection;
        },
        []
      );
      /* eslint-enable no-param-reassign */
    }
    return unfilteredData;
  };

  let unfilteredNumberOfAgeResults = 0;
  if (results && results.unfilteredTotalAgeGroupsCount) {
    if (ageFilteringOnSelection && results.totalAgeGroupsCount) {
      unfilteredNumberOfAgeResults =
        results.unfilteredTotalAgeGroupsCount - results.totalAgeGroupsCount;
    } else {
      unfilteredNumberOfAgeResults = results.unfilteredTotalAgeGroupsCount;
    }
  }

  let unfilteredNumberOfGenderResults;
  if (results && results.unfilteredTotalAgeGroupsCount) {
    if (genderFilteringOnSelection && results.totalGenderGroupsCount) {
      unfilteredNumberOfGenderResults =
        results.unfilteredTotalGenderGroupsCount -
        results.totalGenderGroupsCount;
    } else {
      unfilteredNumberOfGenderResults =
        results.unfilteredTotalGenderGroupsCount;
    }
  }

  return (
    <div className="demographic-results-container">
      <div
        className="filter-results-container"
        ref={elem => setGenderGroupsParent(elem)}
      >
        <div className="filter-results-options-container">
          <div className="filter-results-title">Gender</div>
          {activeFilters && activeFilters.length && !activeGenderFilters ? (
            <div
              role="presentation"
              onClick={() => setGenderDemograpicsActions(prev => !prev)}
              ref={dropdownTogglerRef}
            >
              <span className="filter-results-options-button">...</span>
            </div>
          ) : null}
        </div>
        {results && results.genders && headerStats && headerStats.responses ? (
          <Bar
            data={[
              { x: '', xLabel: '', y: 0 },
              ...results.genders.filter(d =>
                availableGenderGroupsInChart.includes(d.xLabel)
              ),
              { x: ' ', xLabel: ' ', y: 0 }
            ]}
            color="#5200F1"
            parent={genderGroupsParent}
            height="170"
            onChartClick={onToggleFilter}
            tickFrequency="1"
            filterCollectDataGroup={filterCollectDataGroups[0]}
            unfilteredDemographicGroupsData={unfilteredGenderGroupsData}
            numberOfResults={
              results && results.totalGenderGroupsCount
                ? results.totalGenderGroupsCount
                : 0
            }
            unfilteredNumberOfResults={unfilteredNumberOfGenderResults}
            displayRatingPercentage
            displayPercentageYLabel
            groupChartTypeNames={groupTypes}
            groupsChartType={groupTypes.genders}
            activeFilteringOnThisChart={activeGenderFilters}
          />
        ) : null}
        <div>
          <DemographicsRangeSelector
            onToggleFilter={onToggleFilter}
            activeFilters={activeFilters}
            showRangeSelector={null}
            setShowRangeSelector={null}
            demographicsActions={genderDemographicsActions}
            setDemograpicsActions={setGenderDemograpicsActions}
            dropdownTogglerRef={dropdownTogglerRef}
            showCompareToTotalSample={
              activeFilters && activeFilters.length && !activeGenderFilters
            }
            filteringOnSelection={genderFilteringOnSelection}
            setFilteringOnSelection={setGenderFilteringOnSelection}
            isGenderDemographic
          />
        </div>
        {headerStats && !headerStats.responses ? (
          <div className="no-chart-data">No data</div>
        ) : null}
      </div>
      {surveyHasMultipleLanguagesInResults && (
        <div className="filter-results-container">
          <div className="filter-results-title">Language</div>
          {headerStats && headerStats.responses ? (
            <Gauge
              data={results.languages.filter(
                language => language.valueCount > 0
              )}
              width="320"
              height="60"
              onChartClick={onToggleFilter}
              filterCollectDataGroup={filterCollectDataGroups.find(
                filter => filter.name === 'languages'
              )}
            />
          ) : null}
          {headerStats && !headerStats.responses ? (
            <div className="no-chart-data">No data</div>
          ) : null}
        </div>
      )}
      <div
        className="filter-results-container"
        ref={elem => setAgeGroupsParent(elem)}
      >
        <div className="filter-results-options-container">
          <div className="filter-results-title">Age groups</div>
          <div
            role="presentation"
            onClick={() => setAgeDemograpicsActions(prev => !prev)}
            ref={dropdownTogglerRef}
          >
            <span className="filter-results-options-button">...</span>
          </div>
        </div>
        {results &&
        results.ageGroups &&
        headerStats &&
        headerStats.responses ? (
          <Bar
            data={results.ageGroups}
            color="#5200F1"
            parent={ageGroupsParent}
            height="150"
            onChartClick={onToggleFilter}
            tickFrequency="2"
            filterCollectDataGroup={filterCollectDataGroups[1]}
            unfilteredDemographicGroupsData={unfilteredAgeGroupsData}
            numberOfResults={
              results && results.totalAgeGroupsCount
                ? results.totalAgeGroupsCount
                : 0
            }
            unfilteredNumberOfResults={unfilteredNumberOfAgeResults}
            displayRatingPercentage
            displayPercentageYLabel
            groupChartTypeNames={groupTypes}
            groupsChartType={groupTypes.ageGroups}
            activeFilteringOnThisChart={activeAgeFilters}
          />
        ) : null}
        <div>
          <DemographicsRangeSelector
            onToggleFilter={onToggleFilter}
            activeFilters={activeFilters}
            showRangeSelector={showRangeSelector}
            setShowRangeSelector={setShowRangeSelector}
            demographicsActions={ageDemographicsActions}
            setDemograpicsActions={setAgeDemograpicsActions}
            dropdownTogglerRef={dropdownTogglerRef}
            showCompareToTotalSample={
              activeFilters && activeFilters.length && !activeAgeFilters
            }
            filteringOnSelection={ageFilteringOnSelection}
            setFilteringOnSelection={setAgeFilteringOnSelection}
            isGenderDemographic={false}
          />
        </div>
        {headerStats && !headerStats.responses ? (
          <div className="no-chart-data">No data</div>
        ) : null}
      </div>
      {/*
        <div
          className="filter-results-container"
          ref={elem => setEmploymentParent(elem)}
        >
          <div className="filter-results-title">Employment</div>
          {results &&
          results.employementTypes &&
          headerStats &&
          headerStats.responses ? (
            <Bar
              data={results.employementTypes}
              color="#5200F1"
              parent={employmentParent}
              height="150"
              onChartClick={onToggleFilter}
              tickFrequency="4"
              filterCollectDataGroup={filterCollectDataGroups[2]}
            />
          ) : null}
          {headerStats && !headerStats.responses ? (
            <div className="no-chart-data">No data</div>
          ) : null}
        </div>
        */}
    </div>
  );
};

export default Demographics;
